/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fuzE93KTc4ZKNBYf3LAfy
// Component: 5RLoIE7-j5

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fuzE93KTc4ZKNBYf3LAfy/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_context_menu_indicator.css"; // plasmic-import: fuzE93KTc4ZKNBYf3LAfy/projectcss
import sty from "./PlasmicMenuIndicator.module.css"; // plasmic-import: 5RLoIE7-j5/css

import DownloadSvgIcon from "./icons/PlasmicIcon__DownloadSvg"; // plasmic-import: s7v30LEVvl/icon

createPlasmicElementProxy;

export type PlasmicMenuIndicator__VariantMembers = {
  interactive: "interactive";
  isRecording: "isRecording";
};
export type PlasmicMenuIndicator__VariantsArgs = {
  interactive?: SingleBooleanChoiceArg<"interactive">;
  isRecording?: SingleBooleanChoiceArg<"isRecording">;
};
type VariantPropType = keyof PlasmicMenuIndicator__VariantsArgs;
export const PlasmicMenuIndicator__VariantProps = new Array<VariantPropType>(
  "interactive",
  "isRecording"
);

export type PlasmicMenuIndicator__ArgsType = {};
type ArgPropType = keyof PlasmicMenuIndicator__ArgsType;
export const PlasmicMenuIndicator__ArgProps = new Array<ArgPropType>();

export type PlasmicMenuIndicator__OverridesType = {
  root?: Flex__<"button">;
  dropSmoothCorners?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultMenuIndicatorProps {
  interactive?: SingleBooleanChoiceArg<"interactive">;
  isRecording?: SingleBooleanChoiceArg<"isRecording">;
  className?: string;
}

const $$ = {};

function PlasmicMenuIndicator__RenderFunc(props: {
  variants: PlasmicMenuIndicator__VariantsArgs;
  args: PlasmicMenuIndicator__ArgsType;
  overrides: PlasmicMenuIndicator__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "interactive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.interactive,
      },
      {
        path: "isRecording",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.isRecording,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__fuzE9",
        "root_reset_fuzE93KTc4ZKNBYf3LAfy",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootinteractive]: hasVariant(
            $state,
            "interactive",
            "interactive"
          ),
        }
      )}
      tabIndex={-1}
    >
      <div
        data-plasmic-name={"dropSmoothCorners"}
        data-plasmic-override={overrides.dropSmoothCorners}
        className={classNames("all", sty.dropSmoothCorners, {
          [sty.dropSmoothCornersinteractive]: hasVariant(
            $state,
            "interactive",
            "interactive"
          ),
          [sty.dropSmoothCornersisRecording]: hasVariant(
            $state,
            "isRecording",
            "isRecording"
          ),
        })}
      >
        <DownloadSvgIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames("all", sty.svg)}
          role={"img"}
        />
      </div>
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "dropSmoothCorners", "svg"],
  dropSmoothCorners: ["dropSmoothCorners", "svg"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  dropSmoothCorners: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMenuIndicator__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMenuIndicator__VariantsArgs;
    args?: PlasmicMenuIndicator__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicMenuIndicator__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMenuIndicator__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMenuIndicator__ArgProps,
          internalVariantPropNames: PlasmicMenuIndicator__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicMenuIndicator__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMenuIndicator";
  } else {
    func.displayName = `PlasmicMenuIndicator.${nodeName}`;
  }
  return func;
}

export const PlasmicMenuIndicator = Object.assign(
  // Top-level PlasmicMenuIndicator renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dropSmoothCorners: makeNodeComponent("dropSmoothCorners"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicMenuIndicator
    internalVariantProps: PlasmicMenuIndicator__VariantProps,
    internalArgProps: PlasmicMenuIndicator__ArgProps,
  }
);

export default PlasmicMenuIndicator;
/* prettier-ignore-end */
